module.exports = __webpack_public_path__ + "static/media/pro-1.5b409b60.jpg";